// extracted by mini-css-extract-plugin
module.exports = {"container":"Receipt_container__25K5a","receiptList":"Receipt_receiptList__1S095"};